export const convertTo24HourFormat = (time12h: string, period?: string): string => {
  const [hours, minutes] = time12h.split(':'); // Split time into hours and minutes

  // Convert hours to a number
  let hours24 = parseInt(hours, 10);

  if (period === 'AM') {
    if (hours24 === 12) {
      hours24 = 0; // 12 AM is midnight (00:00)
    }
  } else if (period === 'PM') {
    if (hours24 !== 12) {
      hours24 += 12; // Add 12 hours for PM times (except for 12 PM)
    }
  }

  // Ensure the hours are two digits
  const formattedHours = hours24.toString().padStart(2, '0');

  return `${formattedHours}:${minutes}`;
};
